/**
 * 加密工具 — 基于 CryptoJS
 *
 * 直接暴露 CryptoJS 原始对象（ttx.crypto.CryptoJS），同时封装常用方法：
 *   - AES 加解密（CBC/Pkcs7，UTF-8）
 *   - MD5 / SHA1 / SHA256 / SHA512 摘要
 *   - Base64 编解码
 *   - HMAC-MD5 / HMAC-SHA256
 *
 * 使用示例：
 *   ttx.crypto.md5('abc')                          // '900150983cd24fb0d6963f7d28e17f72'
 *   ttx.crypto.sha256('abc')                       // 'ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad'
 *   ttx.crypto.base64Encode('hello')               // 'aGVsbG8='
 *   ttx.crypto.base64Decode('aGVsbG8=')            // 'hello'
 *   ttx.crypto.aesEncrypt('text', 'key', 'iv')     // 密文（Base64）
 *   ttx.crypto.aesDecrypt(cipher, 'key', 'iv')     // 'text'
 *   ttx.crypto.hmacSha256('msg', 'secret')         // HMAC-SHA256 十六进制字符串
 *
 * 需要更底层能力时直接使用 ttx.crypto.CryptoJS 调用完整 API。
 */
import CryptoJS from 'crypto-js';

window.ttx = window.ttx || {};
ttx.crypto = ttx.crypto || {};

(function () {
    // 直接暴露 CryptoJS 原始对象，调用方可使用完整 API
    ttx.crypto.CryptoJS = CryptoJS;

    // ── 哈希摘要（返回十六进制字符串） ─────────────────────────────
    ttx.crypto.md5 = function (message) {
        return CryptoJS.MD5(message).toString();
    };

    ttx.crypto.sha1 = function (message) {
        return CryptoJS.SHA1(message).toString();
    };

    ttx.crypto.sha256 = function (message) {
        return CryptoJS.SHA256(message).toString();
    };

    ttx.crypto.sha512 = function (message) {
        return CryptoJS.SHA512(message).toString();
    };

    // ── Base64 编解码（UTF-8 安全） ───────────────────────────────
    ttx.crypto.base64Encode = function (str) {
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str));
    };

    ttx.crypto.base64Decode = function (base64Str) {
        return CryptoJS.enc.Base64.parse(base64Str).toString(CryptoJS.enc.Utf8);
    };

    // ── HMAC ──────────────────────────────────────────────────────
    ttx.crypto.hmacMd5 = function (message, key) {
        return CryptoJS.HmacMD5(message, key).toString();
    };

    ttx.crypto.hmacSha256 = function (message, key) {
        return CryptoJS.HmacSHA256(message, key).toString();
    };

    // ── AES（CBC / Pkcs7 / UTF-8） ────────────────────────────────
    // key/iv 为字符串，内部按 UTF-8 解析；密文以 Base64 返回
    ttx.crypto.aesEncrypt = function (plainText, key, iv) {
        const keyBytes = CryptoJS.enc.Utf8.parse(key);
        const ivBytes = CryptoJS.enc.Utf8.parse(iv);
        const encrypted = CryptoJS.AES.encrypt(plainText, keyBytes, {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString(); // Base64
    };

    ttx.crypto.aesDecrypt = function (cipherText, key, iv) {
        const keyBytes = CryptoJS.enc.Utf8.parse(key);
        const ivBytes = CryptoJS.enc.Utf8.parse(iv);
        const decrypted = CryptoJS.AES.decrypt(cipherText, keyBytes, {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    };
})();
